import { Component, Prop, Vue } from 'vue-property-decorator';
import { reportFormValidity } from '@/helpers/Validation';
import FormInput2 from '@/components/forms/FormInput2.vue';
import { apiErrorMessageOrRethrow } from '@/errors/helpers';
// TODO Merge/deduplicate with <PromoCodesModal> component.
@Component({
    name: 'CodeModal',
    components: { FormInput2 },
})
export default class CodeModal extends Vue {
    t;
    @Prop({ required: true })
    message;
    @Prop({ required: true })
    applyCallback;
    error = '';
    code = '';
    loading = false;
    onSubmit() {
        this.loading = true;
        reportFormValidity(this.$refs.form)
            .then(() => this.applyCallback(this.code))
            .then(() => this.$modals.close())
            .catch((err) => {
            if (!err.validationError) {
                this.error = apiErrorMessageOrRethrow(err, ['code_exhausted', 'code_not_found', 'no_code_benefit']);
            }
        })
            .finally(() => (this.loading = false));
    }
}
